(function () {
  Window.data = Window.data || {};
  Window.data.csv = Window.data.csv || {};

  Window.data.csv.piramide = [
    {
      grupo: "< 5",
      sexo: "HOMBRES",
      no_vacunadas: 934,
      vacunadas: 122,
      total: 1056,
      porcentaje_no_vacunadas: 88.45,
      porcentaje_vacunadas: 11.55,
    },
    {
      grupo: "< 5",
      sexo: "MUJERES",
      no_vacunadas: 917,
      vacunadas: 129,
      total: 1046,
      porcentaje_no_vacunadas: 87.67,
      porcentaje_vacunadas: 12.33,
    },
    {
      grupo: "5 - 9",
      sexo: "HOMBRES",
      no_vacunadas: 456,
      vacunadas: 89,
      total: 545,
      porcentaje_no_vacunadas: 83.67,
      porcentaje_vacunadas: 16.33,
    },
    {
      grupo: "5 - 9",
      sexo: "MUJERES",
      no_vacunadas: 420,
      vacunadas: 84,
      total: 504,
      porcentaje_no_vacunadas: 83.33,
      porcentaje_vacunadas: 16.67,
    },
    {
      grupo: "10 - 14",
      sexo: "HOMBRES",
      no_vacunadas: 368,
      vacunadas: 81,
      total: 449,
      porcentaje_no_vacunadas: 81.96,
      porcentaje_vacunadas: 18.04,
    },
    {
      grupo: "10 - 14",
      sexo: "MUJERES",
      no_vacunadas: 304,
      vacunadas: 67,
      total: 371,
      porcentaje_no_vacunadas: 81.94,
      porcentaje_vacunadas: 18.06,
    },
    {
      grupo: "15 - 19",
      sexo: "HOMBRES",
      no_vacunadas: 355,
      vacunadas: 56,
      total: 411,
      porcentaje_no_vacunadas: 86.37,
      porcentaje_vacunadas: 13.63,
    },
    {
      grupo: "15 - 19",
      sexo: "MUJERES",
      no_vacunadas: 337,
      vacunadas: 37,
      total: 374,
      porcentaje_no_vacunadas: 90.11,
      porcentaje_vacunadas: 9.89,
    },
    {
      grupo: "20 - 24",
      sexo: "HOMBRES",
      no_vacunadas: 331,
      vacunadas: 48,
      total: 379,
      porcentaje_no_vacunadas: 87.34,
      porcentaje_vacunadas: 12.66,
    },
    {
      grupo: "20 - 24",
      sexo: "MUJERES",
      no_vacunadas: 388,
      vacunadas: 62,
      total: 450,
      porcentaje_no_vacunadas: 86.22,
      porcentaje_vacunadas: 13.78,
    },
    {
      grupo: "25 - 29",
      sexo: "HOMBRES",
      no_vacunadas: 367,
      vacunadas: 67,
      total: 434,
      porcentaje_no_vacunadas: 84.56,
      porcentaje_vacunadas: 15.44,
    },
    {
      grupo: "25 - 29",
      sexo: "MUJERES",
      no_vacunadas: 402,
      vacunadas: 91,
      total: 493,
      porcentaje_no_vacunadas: 81.54,
      porcentaje_vacunadas: 18.46,
    },
    {
      grupo: "30 - 34",
      sexo: "HOMBRES",
      no_vacunadas: 317,
      vacunadas: 73,
      total: 390,
      porcentaje_no_vacunadas: 81.28,
      porcentaje_vacunadas: 18.72,
    },
    {
      grupo: "30 - 34",
      sexo: "MUJERES",
      no_vacunadas: 354,
      vacunadas: 78,
      total: 432,
      porcentaje_no_vacunadas: 81.94,
      porcentaje_vacunadas: 18.06,
    },
    {
      grupo: "35 - 39",
      sexo: "HOMBRES",
      no_vacunadas: 207,
      vacunadas: 39,
      total: 246,
      porcentaje_no_vacunadas: 84.15,
      porcentaje_vacunadas: 15.85,
    },
    {
      grupo: "35 - 39",
      sexo: "MUJERES",
      no_vacunadas: 247,
      vacunadas: 54,
      total: 301,
      porcentaje_no_vacunadas: 82.06,
      porcentaje_vacunadas: 17.94,
    },
    {
      grupo: "40 - 44",
      sexo: "HOMBRES",
      no_vacunadas: 112,
      vacunadas: 22,
      total: 134,
      porcentaje_no_vacunadas: 83.58,
      porcentaje_vacunadas: 16.42,
    },
    {
      grupo: "40 - 44",
      sexo: "MUJERES",
      no_vacunadas: 156,
      vacunadas: 25,
      total: 181,
      porcentaje_no_vacunadas: 86.19,
      porcentaje_vacunadas: 13.81,
    },
    {
      grupo: "45 - 49",
      sexo: "HOMBRES",
      no_vacunadas: 87,
      vacunadas: 9,
      total: 96,
      porcentaje_no_vacunadas: 90.63,
      porcentaje_vacunadas: 9.38,
    },
    {
      grupo: "45 - 49",
      sexo: "MUJERES",
      no_vacunadas: 98,
      vacunadas: 18,
      total: 116,
      porcentaje_no_vacunadas: 84.48,
      porcentaje_vacunadas: 15.52,
    },
    {
      grupo: "50 - 54",
      sexo: "HOMBRES",
      no_vacunadas: 71,
      vacunadas: 3,
      total: 74,
      porcentaje_no_vacunadas: 95.95,
      porcentaje_vacunadas: 4.05,
    },
    {
      grupo: "50 - 54",
      sexo: "MUJERES",
      no_vacunadas: 66,
      vacunadas: 7,
      total: 73,
      porcentaje_no_vacunadas: 90.41,
      porcentaje_vacunadas: 9.59,
    },
    {
      grupo: "55 - 59",
      sexo: "HOMBRES",
      no_vacunadas: 13,
      vacunadas: 5,
      total: 18,
      porcentaje_no_vacunadas: 72.22,
      porcentaje_vacunadas: 27.78,
    },
    {
      grupo: "55 - 59",
      sexo: "MUJERES",
      no_vacunadas: 20,
      vacunadas: 3,
      total: 23,
      porcentaje_no_vacunadas: 86.96,
      porcentaje_vacunadas: 13.04,
    },
    {
      grupo: "60 - 64",
      sexo: "HOMBRES",
      no_vacunadas: 8,
      vacunadas: 0,
      total: 8,
      porcentaje_no_vacunadas: 100,
      porcentaje_vacunadas: 0,
    },
    {
      grupo: "60 - 64",
      sexo: "MUJERES",
      no_vacunadas: 4,
      vacunadas: 0,
      total: 4,
      porcentaje_no_vacunadas: 100,
      porcentaje_vacunadas: 0,
    },
    {
      grupo: "65 - 69",
      sexo: "HOMBRES",
      no_vacunadas: 1,
      vacunadas: 0,
      total: 1,
      porcentaje_no_vacunadas: 100,
      porcentaje_vacunadas: 0,
    },
    {
      grupo: "65 - 69",
      sexo: "MUJERES",
      no_vacunadas: 3,
      vacunadas: 1,
      total: 4,
      porcentaje_no_vacunadas: 75,
      porcentaje_vacunadas: 25,
    },
    {
      grupo: "70 - 74",
      sexo: "HOMBRES",
      no_vacunadas: 3,
      vacunadas: 0,
      total: 3,
      porcentaje_no_vacunadas: 100,
      porcentaje_vacunadas: 0,
    },
    {
      grupo: "70 - 74",
      sexo: "MUJERES",
      no_vacunadas: 2,
      vacunadas: 0,
      total: 2,
      porcentaje_no_vacunadas: 100,
      porcentaje_vacunadas: 0,
    },
  ];
})();
